/**
 * Aide contextuelle — Facturation ESET (clients AMC).
 * Phase 1 = fiche des quantités. Phase 2 (à venir) = tarifs + injection Odoo.
 */

const esetBillingHelp = {
  '/eset/billing': {
    title: 'Facturation ESET (AMC)',
    user: [
      {
        heading: 'À quoi sert cette page ?',
        content: `Vue mensuelle des **quantités** de licences ESET consommées par chaque **client AMC** (Assistance Maintenance Contrat). Chaque carte montre les licences du client (produit, code, sièges, état, expiration). On facture le **mois écoulé** : au 1er juin, place-toi sur « mai » pour voir ce qui a été consommé en mai.`,
      },
      {
        heading: 'Phase 1 vs Phase 2',
        content: `**Phase 1 (cette page)** : on visualise les quantités, sans prix ni injection. **Phase 2 (à venir)** : chaque produit ESET reçoit sa **fiche service** dans le catalogue, tu y renseignes le tarif, et un bouton **Injecter** poussera \`quantité × tarif\` dans la facture brouillon Odoo (comme ALSO).`,
      },
      {
        heading: 'Pourquoi un client est « AMC » ?',
        content: `Un client est marqué AMC depuis la page **Licences ESET** (bouton « Client AMC »). Seuls les clients AMC apparaissent ici. Le prix ESET n'est PAS fourni par l'API : c'est nous qui le maîtrisons via la fiche service du catalogue.`,
      },
      {
        heading: 'Mois clos vs mois en cours',
        content: `**Mois clos ✓** : snapshot figé, la quantité ne bouge plus (sera injectable en Phase 2).\n**Mois en cours (indicatif)** : recalculé chaque heure, non finalisé — on ne facture pas un mois tant qu'il n'est pas terminé.\n\n⚠️ L'historique démarre au déploiement : on ne peut pas reconstituer un mois antérieur (la donnée passée n'existe pas côté ESET).`,
      },
      {
        heading: 'Statuts de carte',
        content: `**Lié Odoo** : société du portail liée + partenaire Odoo (prête pour l'injection Phase 2).\n**Pas de partenaire Odoo** : société liée mais sans \`odoo_partner_id\` (à lier).\n**Société non liée** : client ESET sans mapping vers une société du portail (compléter le mapping ESET).`,
      },
    ],
    admin: [
      {
        heading: 'Endpoints',
        content: `\`GET /api/billing/eset/periods\` — périodes disponibles (eset_billing.view).\n\`GET /api/billing/eset/aggregate?period=YYYY-MM\` — quantités par client AMC (eset_billing.view).\n\`POST /api/billing/eset/sync\` — recompute mois courant + freeze mois clos (eset_billing.admin).\n\`POST /api/billing/eset/link-odoo\` — lie \`odoo_partner_id\` à une société (eset_billing.manage).`,
      },
      {
        heading: 'Source des données & quantité facturable',
        content: `Quantités lues dans \`license_cache\` (état courant ESET), filtrées sur les customers AMC (\`customer_overrides.client_amc=true\`). **Facturable = max(contractuel, déployé)** = \`max(quantity, usage)\` : on facture les postes réellement actifs, et au moins le contrat. Un poste **surdéployé** (ex. 32 actifs sur 30 licences) est facturé 32 et signalé ⚠. Affichage : on montre toute licence **exploitée** (\`usage>0\`) même en état « Erreur » (= quota dépassé, pas expiré) ; états ESET 0=Erreur/1=Normal/2=Obsolète/3=Suspendu/4=Attention (≠ essai — l'essai est le booléen \`trial\`).`,
      },
      {
        heading: 'Snapshot mensuel',
        content: `La tâche planifiée \`eset_billing_recompute\` (1×/h) recalcule le mois courant (\`frozen=false\`) et **fige le mois précédent une seule fois** (\`frozen=true\`) au passage de mois. Robuste aux reboots, idempotent.`,
      },
      {
        heading: 'Fiches service (catalogue)',
        content: `Pour chaque \`productCode\` ESET consommé, une **fiche service** est auto-créée en brouillon dans le catalogue (\`external_refs.eset.product_code\`, catégorie service/licence_securite), avec notification cloche. Active-la et renseigne le \`selling_price_ht\` : c'est ce tarif qui sera injecté en Phase 2 (pas de fallback prix, contrairement à ALSO).`,
      },
    ],
  },
};

export default esetBillingHelp;
